import { Product } from './Product';
import { Variant } from './Product/Variant';
import Dinero from 'dinero.js';
import { DistributionType } from './Order';
var OrderItem = /** @class */ (function () {
    function OrderItem() {
        this.product = new Product();
    }
    OrderItem.prototype.toApi = function () {
        var _a;
        console.log("OrderItem toAPi() call");
        console.log(this);
        return {
            id: this.id,
            cartId: this.cartId,
            orderId: this.orderId,
            productId: this.productId,
            product: this.product.toApi ? this.product.toApi() : null,
            distributionType: this.distributionType.toString(),
            variantId: this.variantId,
            variant: this.variant.toApi(),
            price: this.price.getAmount(),
            tax: (_a = this.tax.getAmount()) !== null && _a !== void 0 ? _a : 0,
        };
    };
    OrderItem.createFromApi = function (dto) {
        var _a;
        var tax = Dinero({ amount: Math.round(((_a = dto.tax) !== null && _a !== void 0 ? _a : 0) * 100), currency: "USD" });
        return Object.assign(new OrderItem(), dto, {
            variant: dto.variant ? Variant.createFromApi(dto.variant) : null,
            price: Dinero({ amount: Math.round(dto.price * 100), currency: "USD" }),
            tax: tax,
            distributionType: dto.distributionType == "Print" ? DistributionType.Print : DistributionType.Digital,
            product: Product.createFromApi(dto.product)
        });
    };
    return OrderItem;
}());
export { OrderItem };
var CountedOrderItem = /** @class */ (function () {
    function CountedOrderItem() {
    }
    return CountedOrderItem;
}());
export { CountedOrderItem };
